import { render, staticRenderFns } from "./UserSummaries.vue?vue&type=template&id=0040b728"
import script from "./UserSummaries.vue?vue&type=script&lang=js"
export * from "./UserSummaries.vue?vue&type=script&lang=js"
import style0 from "./UserSummaries.vue?vue&type=style&index=0&id=0040b728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports